module.exports = __webpack_public_path__ + "static/media/JumboContactImg.2bf01c2d.png";